import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, photoUrl } from "@/lib/api";

export const PhotoUpload = ({ value, onChange, label = "Ambil / unggah foto", testid = "photo-upload", big }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...(e.target.files || [])];
    if (!files.length) return;
    setBusy(true);
    try {
      const up = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        up.push((await api.post("/attachments", fd)).data);
      }
      onChange([...(value || []), ...up]);
    } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
    e.target.value = "";
  };
  return (
    <div>
      <input ref={ref} type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current.click()} data-testid={`${testid}-button`}
        className={`w-full flex items-center justify-center gap-2 border-2 border-dashed border-slate-300 rounded-lg text-slate-600 hover:border-emerald-600 hover:text-emerald-700 hover:bg-emerald-50/50 transition-colors ${big ? "py-8 text-base" : "py-3 text-sm"}`}>
        {busy ? <Loader2 className="animate-spin" size={18} /> : <Camera size={big ? 24 : 18} />} {label}
      </button>
      {!!value?.length && (
        <div className="flex gap-2 flex-wrap mt-2">
          {value.map((p) => (
            <div key={p.id} className="relative">
              <img src={photoUrl(p.id)} alt="" className="w-20 h-20 object-cover rounded border border-slate-200" />
              <button type="button" onClick={() => onChange(value.filter((x) => x.id !== p.id))} className="absolute -top-1.5 -right-1.5 bg-slate-900 text-white rounded-full p-0.5" data-testid="photo-remove"><X size={12} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
